import React from 'react';
import ReactInputMask from 'react-input-mask';
import {stripLeadingZeroes} from '../helpers';

interface NumberInputProps {
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
}

export class IntegerInput extends React.Component<NumberInputProps & Omit<React.InputHTMLAttributes<HTMLInputElement>, keyof NumberInputProps>> {
  handleChange: React.ChangeEventHandler<HTMLInputElement> =
    (event) => {
      let value = event.target.value;
      this.props.onChange(value);
    };

  handleBlur: React.FocusEventHandler<HTMLInputElement> =
    (event) => {
      const value = event.target.value;
      const after = stripLeadingZeroes(value);
      if (after !== value)
        this.props.onChange(after);
      if (this.props.onBlur)
        this.props.onBlur();
    };

  render() {
    let {value, onChange, onBlur, ...rest} = this.props;

    return (
      <ReactInputMask mask="9999999999"
                      value={value}
                      onChange={this.handleChange}
                      onBlur={this.handleBlur}
                      {...rest}>
      </ReactInputMask>);
  }
}
